/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Awvent - Subscriptions API
 * Awvent Subscriptions Apis
 *
 * OpenAPI spec version: v1
 * Contact: info@prestine.in
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type SubscriptionStatus = 'TrialFuture' | 'TrialStarted' | 'TrailExpired' | 'TrailExtensionStarted' | 'TrailExtensionExpired' | 'TrialCancelled' | 'Future' | 'Active' | 'Inactive' | 'Paused' | 'Expired' | 'ScheduledForCancellation' | 'Cancelled';

export const SubscriptionStatus = {
    TrialFuture: 'TrialFuture' as SubscriptionStatus,
    TrialStarted: 'TrialStarted' as SubscriptionStatus,
    TrailExpired: 'TrailExpired' as SubscriptionStatus,
    TrailExtensionStarted: 'TrailExtensionStarted' as SubscriptionStatus,
    TrailExtensionExpired: 'TrailExtensionExpired' as SubscriptionStatus,
    TrialCancelled: 'TrialCancelled' as SubscriptionStatus,
    Future: 'Future' as SubscriptionStatus,
    Active: 'Active' as SubscriptionStatus,
    Inactive: 'Inactive' as SubscriptionStatus,
    Paused: 'Paused' as SubscriptionStatus,
    Expired: 'Expired' as SubscriptionStatus,
    ScheduledForCancellation: 'ScheduledForCancellation' as SubscriptionStatus,
    Cancelled: 'Cancelled' as SubscriptionStatus
};
